export const PROXY_DIR = 'proxies'
export const PROXY_SCHEMA_VERSION = 4
